import React, { useState } from 'react'
import { MaintenanceMessageContent } from '../../models/polymer/MaintenanceMessage.model';

interface HTMLProps {
  [key: string]: string;
}

const parseHTML = (htmlString: string) => {
  // This is a very basic parser and does not handle all HTML tags or attributes.
  // For more complex HTML, consider using a library like DOMPurify.
  const div = document.createElement('div');
  div.innerHTML = htmlString;
  return Array.from(div.childNodes).map((node) => parseNode(node));
};

const parseNode = (node: Node): React.ReactNode => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent;
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    const element = node as HTMLElement;
    const tagName = element.tagName;
    const attributes = element.attributes;
    const childNodes = element.childNodes;
    
    const children = Array.from(childNodes).map((childNode) => parseNode(childNode));
    const props: HTMLProps = {};
    
    Array.from(attributes).forEach((attr: Attr) => {
      props[attr.name] = attr.value;
    });

    if (tagName.toLowerCase() === "a") {
      props.className = (props.className ? props.className + " " : "") + "polymer-header-alert-white-link";
    }
    
    return React.createElement(tagName.toLowerCase(), props, children);
  }
  return null;
};

export interface HeaderAlertV2Props{
  headerAlertContent: MaintenanceMessageContent[],
  onClose: () => void
}

function HeaderAlertV2({headerAlertContent, onClose}: HeaderAlertV2Props) {
  const [currentAlertNum, setCurrentAlertNum] = useState<number>(1);

  const prevAlert = () => {
    currentAlertNum !== 1
    ? setCurrentAlertNum(currentAlertNum-1)
    : setCurrentAlertNum(headerAlertContent.length)
  }
  const nextAlert = () => {
    currentAlertNum !== headerAlertContent.length
    ? setCurrentAlertNum(currentAlertNum+1)
    : setCurrentAlertNum(1)
  }

  return (
    <div className='polymer-header-alert-v2'>
        <div className='polymer-header-alert-v2-container'>
            <div className='polymer-header-alert-v2-bell-icon'>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-bell"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" /><path d="M9 17v1a3 3 0 0 0 6 0v-1" /></svg>      
            </div>
            <div className='polymer-header-alert-v2-item-container'>
                <div className='polymer-header-alert-v2-notice-close-container'>
                    <div className='polymer-header-alert-v2-notice-container'>
                        <div className='polymer-header-alert-v2-title-container'>
                            <p>{headerAlertContent.length > 0 ? headerAlertContent[currentAlertNum - 1].title : ""}</p>
                        </div>
                        <div className='polymer-header-alert-v2-content-container'>
                            {headerAlertContent.length > 0 && parseHTML(headerAlertContent[currentAlertNum - 1].content)}
                        </div>
                    </div>
                    <div onClick={onClose} className='polymer-header-alert-v2-close-icon' aria-label='Close'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18 6l-12 12" /><path d="M6 6l12 12" /></svg>
                    </div>
                </div>
                <div className='polymer-header-alert-v2-pagination-container'>
                    <div onClick={() => {prevAlert()}} className={`polymer-header-alert-v2-pagination-arrow ${currentAlertNum === 1 ? 'polymer-header-alert-v2-pagination-arrow-disabled' : ''}`} aria-label='Previous'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6" /></svg>
                    </div>
                    <p><strong>{currentAlertNum}</strong> of {headerAlertContent.length}</p>
                    <div onClick={() => {nextAlert()}} className={`polymer-header-alert-v2-pagination-arrow ${currentAlertNum === headerAlertContent.length ? 'polymer-header-alert-v2-pagination-arrow-disabled' : ''}`} aria-label='Next'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6" /></svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default HeaderAlertV2;